import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";
import cardImage from "../../assets/images/pages/first-time-driver.jpg";
import "./FourHourBDI.css";

const ExamenTeorico = () => {
    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">
                                Examen teórico para la Licencia del Estado de la Florida
                            </h1>
                        </div>
                    </div>
                </div>
            </section>

            <main className="bdi-page mb-3">
                <div className="container mt-5">
                    <div className="row mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-4">
                                        <img
                                            src={cardImage} // Using the same image as reference for now, can be changed if user provides a specific one
                                            alt="Examen Teórico"
                                            className="img-fluid rounded shadow"
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <h5 className="fw-bold text-warning mb-3">
                                            ¡No necesita esperar en línea en DHSMV para tomar su
                                            examen y no tiene que vivir en Miami!
                                        </h5>
                                        <p className="mb-3">
                                            ¡Cualquier persona menor de los 18 años de edad es
                                            elegible para completar el examen teórico por internet! No
                                            importa cómo, donde o con quien haya echo el Curso de
                                            Alcohol y Drogas. Aunque usted haya completado el curso en
                                            un aula de nuestras oficinas en Miami o cualquier otra
                                            escuela, usted seguiría siendo elegible para tomar este
                                            examen.
                                        </p>
                                        <p className="mb-3">
                                            El Examen Teórico que nosotros ofrecemos por internet,
                                            puede ser tomado por aquellos que quieren obtener una
                                            licencia restringida o la Licencia de Conducción del
                                            Estado de la Florida. El Examen consiste de 50 preguntas
                                            que abarcan:
                                        </p>
                                        <ul className="mb-4">
                                            <li>Señales de tránsito/trafico</li>
                                            <li>Leyes de trafico/transito</li>
                                        </ul>

                                        <p className="mb-2 fw-bold">
                                            Para comenzar el examen Teórico, <a href="https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=NTE0" target="_blank" rel="noreferrer" className="text-warning">¡Regístrese ahora!</a>
                                        </p>
                                        <p className="mb-2 fw-bold">
                                            <a href="/florida-driver-handbook" className="text-warning">
                                                Haga clic aquí para acceder al Manual del Conductor.
                                            </a>
                                        </p>
                                        <p className="mb-4">
                                            Si tiene alguna pregunta, llámenos al 1-888-41-Metro
                                        </p>

                                        <div
                                            className="p-4 rounded mb-4 text-center"
                                            style={{
                                                backgroundColor: "#252525",
                                                borderRadius: "8px",
                                                border: "2px solid var(--metro-yellow)",
                                            }}
                                        >
                                            <h3 className="text-white mb-3">Examen Teórico</h3>
                                            <div className="mb-3">
                                                <span
                                                    className="display-5 fw-bold text-warning"
                                                >
                                                    $24.95
                                                </span>
                                            </div>
                                            <p className="text-white mb-3">
                                                Puede hacer el pago con tarjeta de debito o crédito a través de nuestro método de pago seguro.
                                            </p>

                                            <div className="d-flex flex-wrap justify-content-center gap-3">
                                                <a
                                                    href="https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=NTE0"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                                    style={{ minWidth: "200px" }}
                                                >
                                                    Registrarme Ahora
                                                </a>
                                                <a
                                                    href="/curso-para-obtener-la-licencia"
                                                    className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                                    style={{ minWidth: "200px" }}
                                                >
                                                    ¡Comprar un Paquete y Ahorrar!
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default ExamenTeorico;
